export default __webpack_public_path__ + "static/media/alert.d5426c25.mp3";